import React, { useRef, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import LocationModal from '../common/LocationModal/LocationModal';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import config from '../config';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const OnboardingForm = () => {

  const location = useLocation();
  const { businessId } = location.state || {};  // Accessing businessId from state
  const [selectedLocation, setSelectedLocation] = useState({
    lat: 28.7041,
    lng: 77.1025,
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  // Modal state
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState('');
  const [modalFooter, setModalFooter] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [isMenuSelected, setIsMenuSelected] = useState(null);
  const [isProductSelected, setIsProductSelected] = useState(null);

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      if (file) {
        reader.readAsDataURL(file);
      } else {
        reject('No file selected');
      }
    });
  };
  const formik = useFormik({
    initialValues: {
      name: '',
      restaurant_name: '',
      email: '',
      phone_no: '',
      address: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      working_hours: '',
      about_us: '',
      website_link: '',
      isLogo: '',
      isMenu: '',
      logo: '',
      menu: '',
      menu_images_zip: '',

    },
    validationSchema: Yup.object({
      name: Yup.string().required('Full Name is required'),
      restaurant_name: Yup.string().required('Business Name is required'),
      email: Yup.string().email('Invalid email address').required('Email is required'),
      phone_no: Yup.string().required('Phone Number is required'),
      address: Yup.string().required('Address is required'),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('State is required'),
      country: Yup.string().required('Country is required'),
      zip: Yup.string().required('ZIP is required'),
      working_hours: Yup.string().required('Working Hours are required'),
      about_us: Yup.string().required('About Us is required'),
      isLogo: Yup.string().required('Please choose an option for application logo'),
      logo: Yup.mixed().test('logo-required', 'Logo is mandatory when no website logo is chosen', function (value) {
        const { isLogo } = this.parent;
        if (isLogo === '0' && !value) {
          return false;
        }
        return true;
      }),
      isMenu: Yup.string().required('Please choose an option for product and images'),
      menu: Yup.mixed().test('menu-required', 'Please upload the product file', function (value) {
        const { isMenu } = this.parent;
        if (isMenu === '0' && !value) {
          return false;
        }
        return true;
      }),
      menu_images_zip: Yup.mixed().test('menu_images_zip-required', 'Please upload the product images file', function (value) {
        const { isMenu } = this.parent;
        if (isMenu === '0' && !value) {
          return false;
        }
        return true;
      }),


    }),

    // onSubmit: async (values) => {
    //   console.log('values',values);
      
    //   setModalVisible(false);
    //   setError('');
    //   setLoading(true);
    //   // setSuccess('');
    //   try {
   
    //     const formData = new FormData();
    //     formData.append('name', values.name);
    //     formData.append('restaurant_name', values.restaurant_name);
    //     formData.append('email', values.email);
    //     formData.append('phone_no', values.phone_no);
    //     formData.append('address', values.address);
    //     formData.append('city', values.city);
    //     formData.append('state', values.state);
    //     formData.append('country', values.country);
    //     formData.append('zip', values.zip);
    //     formData.append('working_hours', values.working_hours);
    //     formData.append('about_us', values.about_us);
    //     formData.append('website_link', values.website_link);
    //     formData.append('isLogo', values.isLogo || '');
    //     formData.append('isMenu', values.isMenu || '');
    //     formData.append('logo', values.logo ? values.logo : ''); 
    //     formData.append('menu', values.menu ? values.menu : ''); 
    //     formData.append('menu_images_zip', values.menu_images_zip ? values.menu_images_zip : ''); 

    //     const token = localStorage.getItem('authToken');
    //     const api = config.apiBaseUrl;

    //     const response = await axios.post(api + 'onboarding/', formData, {
    //       headers: {
    //         'Authorization': `Token ${token}`,
    //       },
    //     });
    //     console.log(response.status);
    //     if (response.status === 201) {
    //       console.log("hiii")
    //       const response1 = await axios.get(api + 'onboarding/'+response.data.id+'/', {
    //         headers: {
    //           'Authorization': `Token `+token ,
    //         },
    //       });
    //       console.log(response1);
    //       const onboardData = {
    //         "name": values.name,
    //         "restaurant_name": values.restaurant_name,
    //         "email": values.email,
    //         "phone_no": values.phone_no,
    //         "address": values.address,
    //         "city": values.city,
    //         "state": values.state,
    //         "country": values.country,
    //         "zip": values.zip,
    //         "working_hours": values.working_hours,
    //         "about_us": values.about_us,
    //         "website_link": values.website_link,
    //         "isLogo": values.isLogo === 0 ? true : false,
    //         "isMenu": values.isMenu === 0 ? true : false,
    //         "logo" : '',
    //         "menu" : '',
    //         "menu_images_zip" : '',
    //       }

    //       const response = await axios.post(api + 'onboarding-request/', onboardData);

    //       setModalTitle('<i class="fa fa-check-circle fa-lg" aria-hidden="true"></i> &nbsp; THANK YOU FOR SUBMITTING ONBOARDING REQUEST!');
    //       setModalBody(`<div>We have received your request, Very soon InstaApp team will start working on your application. In case anything required we will call you or send an email.</div>`);
    //       setModalVisible(true);
    //     } else {
    //       setError('Failed to save onboarding form. please contact admin.');
    //     }

    //   } catch (err) {
    //     setError('Error submitting the form. Please try again.');
    //     setModalVisible(false);
    //   } finally {
    //     setLoading(false); 
    //   }
    // }

    onSubmit: async (values) => {
      console.log('values', values);
      
      setModalVisible(false);
      setError('');
      setLoading(true);
      
      try {
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('restaurant_name', values.restaurant_name);
        formData.append('email', values.email);
        formData.append('phone_no', values.phone_no);
        formData.append('address', values.address);
        formData.append('city', values.city);
        formData.append('state', values.state);
        formData.append('country', values.country);
        formData.append('zip', values.zip);
        formData.append('working_hours', values.working_hours);
        formData.append('about_us', values.about_us);
        formData.append('website_link', values.website_link);
        formData.append('isLogo', values.isLogo || '');
        formData.append('isMenu', values.isMenu || '');
        formData.append('logo', values.logo ? values.logo : '');
        formData.append('menu', values.menu ? values.menu : '');
        formData.append('menu_images', values.menu_images_zip ? values.menu_images_zip : '');
    
        const token = localStorage.getItem('authToken');
        const api = config.apiBaseUrl;
    
        const response = await axios.post(api + 'onboarding/', formData, {
          headers: {
            'Authorization': `Token ${token}`,
          },
        });
    
        console.log('Response Status:', response.status); 
        
        if (response.status === 201) {
          console.log('Successfully submitted onboarding form!');
          
          const response1 = await axios.get(api + 'onboarding/' + response.data.id + '/', {
            headers: {
              'Authorization': `Token ${token}`,
            },
          });
          
          console.log('Onboarding data:', response1); 
    
          const onboardData = {
            "name": values.name,
            "restaurant_name": values.restaurant_name,
            "email": values.email,
            "phone_no": values.phone_no,
            "address": values.address,
            "city": values.city,
            "state": values.state,
            "country": values.country,
            "zip": values.zip,
            "working_hours": values.working_hours,
            "about_us": values.about_us,
            "website_link": values.website_link,
            "isLogo": values.isLogo === 0 ? true : false,
            "isMenu": values.isMenu === 0 ? true : false,
            "logo" : response1.data.logo,
            "menu" : response1.data.menu,
            "menu_images" : response1.data.menu_images,
          };
    
          // Posting the onboarding request
          const response2 = await axios.post(api + 'onboarding-request/', onboardData);
          console.log('Onboarding request response:', response2); 
    
          // Success modal
          setModalTitle('<i class="fa fa-check-circle fa-lg" aria-hidden="true"></i> &nbsp; THANK YOU FOR SUBMITTING ONBOARDING REQUEST!');
          setModalBody(`<div>We have received your request, Very soon InstaApp team will start working on your application. In case anything required we will call you or send an email.</div>`);
          setModalVisible(true);
        } else {
          setError('Failed to save onboarding form. Please contact admin.');
        }
    
      } catch (err) {
        console.error('Error submitting the form:', err);
        setError('Error submitting the form. Please try again.');
        setModalVisible(false);
      } finally {
        setLoading(false);
      }
    }
    

  });

  const closeLocationModal = () => {
    setShowModal(false);
  };

  const onSaveLocation = (addressInfo) => {
    formik.setFieldValue('address', addressInfo.address);
    formik.setFieldValue('city', addressInfo.city);
    formik.setFieldValue('state', addressInfo.state);
    formik.setFieldValue('country', addressInfo.country);
    formik.setFieldValue('zip', addressInfo.postalCode);
    setShowModal(false);
  };


  const handleProductChange = (event) => {
    const { value } = event.target;
    setIsProductSelected(value);
    formik.setFieldValue('isMenu', value);
    if (value === '0') {
      formik.setTouched({ menu: true, menu_images_zip: true });
    }
  };

  const handleLogoChange = (event) => {
    const { value } = event.target;
    formik.setFieldValue('isLogo', value);
    if (value === '1') {
      formik.setFieldValue('logo', ''); // Reset the logo field if "Yes" is selected
    }
  };

  const handlePhoneChange = (value, data) => {
    // Combine the phone code and number
    const fullPhoneNumber = `+${data.dialCode}${value.slice(data.dialCode.length)}`;
    formik.setFieldValue('phone_no', fullPhoneNumber); // Save the concatenated phone number
  };

  return (
    <section className="section-grey section-top-border" id="about">
      <div className={modalVisible ? 'container margin-top-60 content-container blur' : 'container margin-top-60'}>
        <div className="row">
          <div className="col-md-12 text-center">
            <h2 className="section-title">Fill out this form to get access to your Insta App Account</h2>
          </div>
          <div className="col-md-2"></div>
          <div className="col-md-12">
            <form onSubmit={formik.handleSubmit} id="onboarding-form" autoComplete="off" encType="multipart/form-data">
              <div className="form-row">
                <div className="col-md-6 ">
                  <label>Full Name <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.name && formik.errors.name ? 'is-invalid' : ''}`}
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Full Name"
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="invalid-feedback">{formik.errors.name}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>Business Name <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.restaurant_name && formik.errors.restaurant_name ? 'is-invalid' : ''}`}
                    name="restaurant_name"
                    value={formik.values.restaurant_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Business Name"
                  />
                  {formik.touched.restaurant_name && formik.errors.restaurant_name ? (
                    <div className="invalid-feedback">{formik.errors.restaurant_name}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>Email Address <span className="error">*</span></label>
                  <input
                    type="email"
                    className={`form-control ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Email Address"
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="invalid-feedback">{formik.errors.email}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>Phone Number <span className="error">*</span></label>
                  <PhoneInput
                    name="phone_no"
                    country={'in'}
                    preferredCountries={['us', 'in', 'gb']}
                    value={formik.values.phone_no}
                    onChange={handlePhoneChange}
                    // onChange={(value) => formik.setFieldValue('phone_no', value)}
                    onBlur={formik.handleBlur}
                    inputProps={{
                      name: 'phone_no',
                      id: 'phone_no',
                    }}
                    inputStyle={{
                      width: '100%',
                    }}
                    containerStyle={{
                      marginBottom: '10px',
                    }}
                    dropdownStyle={{
                      position: 'absolute',
                      left: '0',
                      zIndex: 10,
                    }}
                  />
                  {formik.touched.phone_no && formik.errors.phone_no ? (
                    <div className="invalid-feedback">{formik.errors.phone_no}</div>
                  ) : null}
                </div>


                <div className="col-md-6 mb-3">
                  <label>Select Location</label>
                  <br />
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(true)}>
                    Choose Location
                  </button>
                </div>

                <div className="col-md-6 mb-3">
                  <label>Address <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.address && formik.errors.address ? 'is-invalid' : ''}`}
                    name="address"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Address"
                  />
                  {formik.touched.address && formik.errors.address ? (
                    <div className="invalid-feedback">{formik.errors.address}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>City <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.city && formik.errors.city ? 'is-invalid' : ''}`}
                    name="city"
                    value={formik.values.city}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter City"
                  />
                  {formik.touched.city && formik.errors.city ? (
                    <div className="invalid-feedback">{formik.errors.city}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>State <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.state && formik.errors.state ? 'is-invalid' : ''}`}
                    name="state"
                    value={formik.values.state}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter State"
                  />
                  {formik.touched.state && formik.errors.state ? (
                    <div className="invalid-feedback">{formik.errors.state}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>Country <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.country && formik.errors.country ? 'is-invalid' : ''}`}
                    name="country"
                    value={formik.values.country}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Country"
                  />
                  {formik.touched.country && formik.errors.country ? (
                    <div className="invalid-feedback">{formik.errors.country}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>ZIP <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.zip && formik.errors.zip ? 'is-invalid' : ''}`}
                    name="zip"
                    value={formik.values.zip}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter ZIP"
                  />
                  {formik.touched.zip && formik.errors.zip ? (
                    <div className="invalid-feedback">{formik.errors.zip}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>Working Hours <span className="error">*</span></label>
                  <input
                    type="text"
                    className={`form-control ${formik.touched.working_hours && formik.errors.working_hours ? 'is-invalid' : ''}`}
                    name="working_hours"
                    value={formik.values.working_hours}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Working Hours"
                  />
                  {formik.touched.working_hours && formik.errors.working_hours ? (
                    <div className="invalid-feedback">{formik.errors.working_hours}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>About Us <span className="error">*</span></label>
                  <textarea style={{ marginBottom: '0px' }}
                    className={`form-control ${formik.touched.about_us && formik.errors.about_us ? 'is-invalid' : ''}`}
                    name="about_us"
                    value={formik.values.about_us}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter About Us"
                  ></textarea>
                  {formik.touched.about_us && formik.errors.about_us ? (
                    <div className="invalid-feedback">{formik.errors.about_us}</div>
                  ) : null}
                </div>

                <div className="col-md-6 mb-3">
                  <label>Website Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="website_link"
                    value={formik.values.website_link}
                    onChange={formik.handleChange}
                    placeholder="Enter Website Link"
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label>Do you want us to choose application logo from your website? <span className="error">*</span></label><br />
                  <input
                    type="radio"
                    name="isLogo"
                    value="1"
                    onChange={handleLogoChange}
                  /> &nbsp; Yes &nbsp;
                  <input
                    type="radio"
                    name="isLogo"
                    value="0"
                    onChange={handleLogoChange}
                  /> &nbsp; No
                  {formik.touched.isLogo && formik.errors.isLogo ? (
                    <div className="text-danger">{formik.errors.isLogo}</div>
                  ) : null}
                </div>

                {formik.values.isLogo === '0' && (
                  <div className="col-md-6 mb-3">
                    <label>
                      Upload Application Logo (1024 * 1024) <span className="error">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="logoUpload"
                      name="logo"
                      placeholder="Select Logo"
                      accept="image/*"
                      onChange={(e) => formik.setFieldValue('logo', e.currentTarget.files[0])}
                    />
                    {formik.touched.logo && formik.errors.logo && (
                      <div className="text-danger">{formik.errors.logo}</div>
                    )}
                  </div>
                )}

                <div className="col-md-6 mb-3">
                  <label>Do you want us to choose product and product images from your website? <span className="error">*</span></label><br />
                  <input
                    type="radio"
                    name="isMenu"
                    value="1"
                    onChange={handleProductChange}
                  /> &nbsp; Yes &nbsp;
                  <input
                    type="radio"
                    name="isMenu"
                    value="0"
                    onChange={handleProductChange}
                  /> &nbsp; No
                  {formik.touched.isMenu && formik.errors.isMenu ? (
                    <div className="text-danger">{formik.errors.isMenu}</div>
                  ) : null}
                </div>


                {/* Product Upload (only shows when 'No' is selected for logo) */}
                {isProductSelected === '0' && (
                  <>

                    <div className="col-md-6 mb-3 menuDiv">
                      <label>
                        Upload Product <span className="error">*</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a
                          href="/assets/format/Upload_Product_Format.xlsx"
                          download="Upload_Product_Format.xlsx"
                          className="blue-color"
                        >
                          DOWNLOAD SAMPLE FORMAT
                        </a>
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="menuUpload"
                        name="menu"
                        placeholder="Select Menu"
                        accept=".xls,.xlsx"
                        onChange={(event) => formik.setFieldValue('menu', event.currentTarget.files[0])} // Update Formik state
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.menu && formik.errors.menu && (
                        <div className="text-danger">{formik.errors.menu}</div>
                      )}
                      <span id="menuMsg" className="error" style={{ display: 'none' }}></span>
                    </div>

                    <div className="col-md-6 mb-3 menuDiv">
                      <label>Upload Product Images (In zip format) <span className="error">*</span></label>
                      <input
                        type="file"
                        className="form-control"
                        id="MenuImageUpload"
                        name="menu_images_zip"
                        placeholder="Select Menu Images ZIP"
                        accept=".zip,.rar,.7zip"
                        onChange={(event) => formik.setFieldValue('menu_images_zip', event.currentTarget.files[0])}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.menu_images_zip && formik.errors.menu_images_zip ? (
                        <div className="text-danger">{formik.errors.menu_images_zip}</div>
                      ) : null}
                      <span id="menuImgMsg" className="error" style={{ display: 'none' }}></span>

                    </div>
                  </>
                )}


                <div className="col-md-8 mb-3">
                  <button className="btn btn-primary btn-lg btn-ext-style"
                    style={{ width: '30%' }} type="submit">
                    Submit
                  </button>
                  <button className="btn btn-secondary btn-lg btn-ext-style ml-4" style={{ width: '30%' }} type="button">
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>


      {/* location modal */}
      <LocationModal
        show={showModal}
        close={closeLocationModal}
        selectedLocation={selectedLocation}
        setSelectedLocation={setSelectedLocation}
        onSaveLocation={onSaveLocation}
      />

      {/* Success Modal */}
      {modalVisible && (
        <div className="modal" style={{
          display: 'block',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '420px',
          backgroundColor: 'white',
          padding: '20px',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          zIndex: '9999',
          textAlign: 'center',
          height: '285px',
        }}>
          <div className="modal-content">
            <h5 style={{ color: '#1ec10f' }} dangerouslySetInnerHTML={{ __html: modalTitle }}></h5>
            <p dangerouslySetInnerHTML={{ __html: modalBody }}></p>
            <div dangerouslySetInnerHTML={{ __html: modalFooter }}></div>
            <button
              type="button"
              style={{
                background: '#0c75fb',
                border: 'none',
                color: '#fff',
                letterSpacing: '1px',
                cursor: 'pointer',
                display: 'inline-block',
                fontSize: '14px',
                fontWeight: '700',
                width: '45%',
                padding: '10px 0',
                textTransform: 'uppercase',
                borderRadius: '3px',
                marginTop: '10px',
                alignSelf: 'center',
                transition: 'all .50s ease-in-out',
              }}
              onClick={() => (window.location.href = '/')}
            >
              ok
            </button>

          </div>
        </div>
      )}

    </section>
  );
};

export default OnboardingForm;
